import app from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/storage";
import "firebase/compat/app-check"; //
// import {connect} from 'react-redux';

// import sushimaster from './sushimaster.json';
// import yasumaki from './yasumaki.json';

class Firebase {
	constructor(props) {
		const { appCheckRecaptchaKey, ...firebaseConfig } = props.config;

		//let data = require(`./${login}.json`);
		app.initializeApp(firebaseConfig);

		// window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

		this.appCheck = null;
		if (appCheckRecaptchaKey) {
			const appCheck = app.appCheck();
			const previousKey =
				typeof window !== "undefined"
					? window.__RECAPTCHA_SITE_KEY__
					: undefined;

			if (previousKey && previousKey !== appCheckRecaptchaKey) {
				if (!window.__APP_CHECK_RELOADING__) {
					window.__APP_CHECK_RELOADING__ = true;
					setTimeout(() => window.location.reload(), 0);
				}
			} else {
				appCheck.activate(
					new app.appCheck.ReCaptchaEnterpriseProvider(appCheckRecaptchaKey),
					true
				);
				window.__RECAPTCHA_SITE_KEY__ = appCheckRecaptchaKey;
				this.appCheck = appCheck;
			}
		}
		this.auth = app.auth();
		this.bd = app.database();
		this.storage = app.storage();
		this.deleteSessions = async () => {
			try {
				await app.app().delete();
			} catch (error) {}
		};
	}

	doSignInWithEmailAndPassword = (email, password) =>
		this.auth.signInWithEmailAndPassword(email, password);

	ensureAppCheckToken = async () => {
		if (!this.appCheck) return;

		await this.appCheck.getToken(true);
	};

	doSignOut = async () => {
		try {
			await this.auth.signOut();
		} catch (error) {}

		await this.deleteSessions();
	};
}

export default Firebase;
